import React from "react";
import { useSelector } from "react-redux";
import ErrorBoundary from "lib/ErrorBoundary";
import { ReadingListNotification } from "./ReadingListNotification";

// Toast notification when an item is added to Reading List
export const ToastNotificationsService = () => {
  const notifications = useSelector((state) => state.misc.notifications);
  if (!notifications || !notifications.length) return null;

  return (
    <ErrorBoundary>
      <section style={{ position: "fixed", right: 0, bottom: "30px", zIndex: 100 }}>
        <div className="d-flex flex-column-reverse justify-content-between">
          {notifications.map((notification, index) => (
            <ReadingListNotification key={index} {...notification} />
          ))}
        </div>
      </section>
    </ErrorBoundary>
  );
};
